































































































































import {
  Vue,
  Component,
  Prop,
} from "vue-property-decorator";

@Component({
  components: {},
})

export default class ButtonGroup extends Vue {
    @Prop()
    public name? : string;
    @Prop()
    public height! : number;

    public style : any = {};
    public contanerStyle : any = {};

    created() {
        this.style.height = this.height * 0.5 + 'px';
        this.style.width = this.height * 0.5 + 'px';
        this.contanerStyle.height = this.height + 'px'
    }
}
